import { create, v, w } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Dialog } from '@dojo/widgets/dialog';

// import { inert } from '@dojo/framework/core/middleware/inert';
// import { bodyScroll } from '@dojo/widgets/middleware/bodyScroll';
// import { GlobalEvent } from '@dojo/widgets/global-event';
// import { formatAriaProperties, Keys } from '@dojo/widgets/common/util';
// import { Icon } from '@holmescorp/base-widgets';
// import { Underlay } from '../../support/underlay';

// CSS
import css from '../../css/expanded.m.css';

export interface ExpandedTopicCardProperties {
	expanded: boolean;
	onRequestClose: () => void;
	aria?: { [key: string]: string | null };
	widgetId?: string;
	title?: string;
	iconUrl?: string;
	xqa?: string;
	height?: number;
	position?: {
		x: number;
		y: number;
	};
	underlay?: boolean;
	extraClasses?: string[];
}

export interface ExpandedBaseCardICache {
	callFocus: boolean;
	wasExpanded: boolean;
}

export interface ExpandedBaseCardChildren {
	content: DNode;
}

const icache = createICacheMiddleware<ExpandedBaseCardICache>();
const factory = create({
	icache,
	theme
})
	.properties<ExpandedTopicCardProperties>()
	.children<ExpandedBaseCardChildren>();

export const ExpandedBaseCard = factory(({ id, properties, children, middleware: { theme } }) => {
	const {
		aria = {},
		expanded: open,
		widgetId = id,
		title,
		iconUrl,
		xqa,
		onRequestClose,
		underlay,
		extraClasses = []
	} = properties();
	const themeCss = theme.classes(css);
	const [{ content }] = children();
	const closeable = true;

	return (
		open &&
		v(
			'div',
			{
				id,
				widgetId,
				key: 'expandedCard',
				xqa,
				classes: [theme.variant(), themeCss.root]
			},
			[
				w(Dialog, { open, aria, closeable, underlay, onRequestClose }, [
					{
						content: v('div', { key: 'skel', classes: [themeCss.skel, ...extraClasses] }, [
							title ? v('h2', { key: 'title', classes: [themeCss.title] }, [title]) : null,
							iconUrl
								? v('div', { key: 'icon', classes: [themeCss.icon] }, [v('img', { src: iconUrl })])
								: null,
							v('div', { key: 'content', classes: [themeCss.expanded_content, xqa] }, [content])
						])
					}
				])
			]
		)
	);
});

export default ExpandedBaseCard;
